import { render, staticRenderFns } from "./PhotosLocationSettings.vue?vue&type=template&id=92be8f4e"
import script from "./PhotosLocationSettings.vue?vue&type=script&lang=js"
export * from "./PhotosLocationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports